import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
section {
  max-width: 1230px;
  padding-left: 32px;
  padding-right: 32px;
  margin: 0 auto;
}
.nav-wrapper {
  max-width: 1230px;
  padding-left: 32px;
  padding-right: 32px;
  margin: 0 auto;
}
nav {
    top: 0px;
    position: -webkit-sticky;
    position: sticky;
}
nav::-webkit-scrollbar {
    /** SWIPE STUFF **/
    display: none;
}
div.tabbed nav {
    position: relative;
}
ul {
    padding: 0;
}
.tabbed section {
    display: none;
}
.tabbed section.active {
    display: block;
}
.sections {
    background-color: #f7f7f7;
}
.page-navigation {
    background-color: #f7f7f7;
}
.page-navigation {
    margin-top: 24px;
}
/* @todo instead of doing this lets make it
  so that if whole section is visible it's active
*/
@media (min-width: 722px) {
    .sections {
        padding-bottom: 32px;
    }
}
`;

export default styles;